enum MediaCardLayout {
  Vertical = 'vertical',
  Avatar = 'avatar',
  Story = 'story',
}

export {
  MediaCardLayout
}
